import { render, staticRenderFns } from "./touristsEvaluation.vue?vue&type=template&id=45196798&scoped=true"
import script from "./touristsEvaluation.vue?vue&type=script&lang=js"
export * from "./touristsEvaluation.vue?vue&type=script&lang=js"
import style0 from "./touristsEvaluation.vue?vue&type=style&index=0&id=45196798&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45196798",
  null
  
)

export default component.exports